import React from 'react';
import MapEventHandlers from 'components/common/MapEventHandlers';
import {useController, useWatch} from 'react-hook-form';
import DraggableMarkers from 'components/common/DraggableMarker';
import {FormControl} from '@mui/material';
import {LatLngLiteral, LeafletMouseEventHandlerFn} from 'leaflet';
import icons, {IconType} from './Icons/MarkerIcons';
import EventMapContainer from './EventMapContainer';
import {EventType} from 'types/App';

const ControlPositionInput = (props: ControlPositionInput) => {
  const {event, multi = false} = props;

  const {
    field: {value: marker, onChange: onChangeMarker}
  } = useController({name: multi ? 'positions' : 'position'});

  const type = useWatch({name: 'type'});

  const handleMapClick: LeafletMouseEventHandlerFn = (e) => {
    if (multi) {
      onChangeMarker([...(marker || []), e.latlng]);
    } else {
      if (!marker) {
        onChangeMarker(e.latlng);
      }
    }
  };

  const handleChangeMarker = (index: number) => (latlng: LatLngLiteral) => {
    marker[index] = latlng;
    onChangeMarker(marker);
  };

  return (
    <FormControl fullWidth>
      <EventMapContainer event={event} className="leaflet-crosshair" style={{width: '100%', height: '500px', position: 'relative'}}>
        <MapEventHandlers click={handleMapClick} />
        {!multi && marker && <DraggableMarkers position={marker} onUpdate={onChangeMarker} icon={icons[(type as IconType) || 'default']} />}
        {multi &&
          marker &&
          marker.map((marker: LatLngLiteral, index: number) => (
            <DraggableMarkers key={index} position={marker} onUpdate={handleChangeMarker(index)} icon={icons[(type as IconType) || 'default']} />
          ))}
      </EventMapContainer>
    </FormControl>
  );
};

export default ControlPositionInput;

type ControlPositionInput = {
  event: EventType;
  multi?: boolean;
};
